import styled from 'styled-components';
import { StyledLinkButton } from '../../../common/components/Button/StyledButtons';
import { HeImgix } from '../../../common/components/images/HeImgix';
import { buildHeImgixUrl } from '../../../common/components/images/imgix';
import { Col, FLEX_COLS, Row } from '../../../common/components/layout/FlexLayout';
import { PageSection } from '../../../common/components/layout/PageSection/PageSection';
import { PageSectionContainer } from '../../../common/components/layout/PageSection/PageSection.styles';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { Breakpoint } from '../../../common/styles/constants';

const sectionBgImage = buildHeImgixUrl('/public/images/he_healthcare_bg_20210805003115.png');

export const DownloadAppContentContainer = styled.div`
  ${FLEX_COLS}
  flex: 1;
  justify-content: center;
  padding: 56px 24px;
  position: relative;

  ${Breakpoint.EXTRA_LARGE} {
    padding: 56px 0px;
  }
`;

export const DownloadAppSectionLeftCol = styled(Col)`
  position: relative;

  ${StyledLinkButton} {
    margin-top: 12px;
    width: auto;
  }

  ${Breakpoint.MEDIUM} {
    align-items: flex-start;
    position: initial;
  }
`;

export const DownloadAppSectionRightCol = styled(Col)`
  align-items: center;
  padding-top: 54px;
  position: relative;

  ${Breakpoint.MEDIUM} {
    padding-top: 0;
    position: initial;
  }
`;

export const DownloadAppSectionRow = styled(Row)`
  flex-direction: column-reverse;

  ${Breakpoint.MEDIUM} {
    align-items: center;
    flex: 1;
    flex-direction: row;
  }
`;

export const DownloadAppPageSection = styled(PageSection)`
  background-color: ${ThemeColours.accent100};
  height: auto;
  overflow: hidden;

  > ${PageSectionContainer} {
    padding: 0;
  }

  ${Breakpoint.MEDIUM} {
    height: 800px;
  }
`;

export const DownloadAppSectionPhoneGraphicLink = styled.a`
  bottom: 0;
  height: 279px;
  width: 229px;

  ${Breakpoint.MEDIUM} {
    bottom: 0;
    height: 529px;
    position: absolute;
    right: 0;
  }

  &:before {
    background-image: url(${sectionBgImage});
    background-position: 0;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: 0;
    content: '';
    display: inline-block;
    height: 317px;
    left: 0;
    pointer-events: none;
    position: absolute;
    width: 100%;

    ${Breakpoint.MEDIUM} {
      background-position: bottom right;
      bottom: 0;
      height: 600px;
      left: -170px;
      position: absolute;
      width: 1343px;
    }
  }
`;

export const DownloadAppSectionPhoneGraphic = styled(HeImgix)`
  display: inline-block;
  height: 100%;
  position: relative;
  z-index: 1;
`;
